import styled from 'styled-components';
import { variant } from 'styled-system';
import { Box } from '../Box/Box';
import { Text } from '../Text/Text';
import { Icon } from '../Icon/Icon';
import { Theme } from '../../../theme/theme';
import { PaddingProps } from '../../../theme/styledProps';
import { CustomRadio } from '../Radio/RadioBase/RadioBase.styles';

export const LabelText = styled(Text)``;
export const HelperText = styled(Text)``;
export const StyledIcon = styled(Icon)``;

export type SizeVariant = 'small' | 'medium';

interface Props {
  disabled?: boolean;
  checked?: boolean;
  sizeVariant: SizeVariant;
  theme: Theme;
}

export const VisualPickerWrapper = styled(Box)<Props>(
  ({ theme, checked, disabled }) => ({
    display: 'flex',
    alignItems: 'center',
    borderRadius: theme.radii.medium,
    borderWidth: '1px',
    borderColor: disabled
      ? theme.colors.neutral['300']
      : checked
      ? theme.colors.primary['300']
      : theme.colors.neutral['300'],
    borderStyle: 'solid',
    backgroundColor: disabled
      ? theme.colors.neutral['100']
      : checked
      ? theme.colors.primary['100']
      : theme.colors.bg,
    boxShadow: disabled ? theme.shadows['50'] : theme.shadows['200'],
    position: 'relative',
    pointerEvents: disabled ? 'none' : 'initial',
    transition: `box-shadow ${theme.transitions.normal}, border ${theme.transitions.normal}, background ${theme.transitions.normal}, color ${theme.transitions.normal}`,

    '&:hover': {
      borderColor: disabled
        ? theme.colors.neutral['300']
        : checked
        ? theme.colors.primary['300']
        : theme.colors.neutral['400'],
      boxShadow: disabled
        ? theme.shadows['50']
        : checked
        ? theme.shadows['200']
        : theme.shadows['400'],
    },

    '[data-whatinput="keyboard"] &:focus-within': {
      borderColor: theme.colors.primary['500'],
      boxShadow: `0 0 0 2px ${theme.colors.primary['300']}`,
    },

    [LabelText]: {
      color: disabled
        ? theme.colors.neutral['500']
        : checked
        ? theme.colors.primary['600']
        : theme.colors.neutral['700'],
      fontFamily: theme.fontFamily,
      fontSize: theme.fontSizes.body,
      lineHeight: theme.lineHeights.body,
      fontWeight: theme.fontWeights['500'],
    },

    [StyledIcon]: {
      color: disabled
        ? theme.colors.neutral['500']
        : checked
        ? theme.colors.primary['500']
        : theme.colors.neutral['500'],
    },

    [HelperText]: {
      color: disabled
        ? theme.colors.neutral['500']
        : checked
        ? theme.colors.primary['600']
        : theme.colors.neutral['500'],
      fontSize: theme.fontSizes.small,
      fontWeight: theme.fontWeights['400'],
      lineHeight: theme.lineHeights.small,
      marginTop: 4,
    },

    [CustomRadio]: {
      display: 'block',
    },
  }),

  variant<PaddingProps, SizeVariant>({
    prop: 'sizeVariant',
    variants: {
      small: {
        px: '16',
        py: 14,
      },

      medium: {
        px: '16',
        py: 19,
      },
    },
  }),
);
